export class ActionCannotBeDeclinedError extends Error {
  constructor() {
    super('Action cannot be declined.');
  }
}
